import { type FC } from 'react'
import { Modal } from '@dhl-ui/components'
import { NativeModal as NativeModalComponent, type NativeModalProps } from './NativeModal.js'
import { ModalHeader } from './ModalHeader.js'

export type { NativeModalProps } from './NativeModal.js'
export * from './useNativeBackdrop.js'

type NativeModalType = typeof Modal & {
  Header: typeof ModalHeader
} & FC<NativeModalProps>

const NativeModal = Object.assign(NativeModalComponent, {
  Content: Modal.Content,
  Header: ModalHeader,
  Footer: Modal.Footer,
}) as NativeModalType

export { NativeModal }
